import Cookies from 'js-cookie';

export default {
  getId() {
    // Get ajs_anonymous_id from cookie
    return Cookies.get('ajs_anonymous_id') || undefined;
  },
};
